import React, { useState } from 'react';
import classNames from 'classnames';
import ImageGallery from 'react-image-gallery';

import { Section, Layout, SEO, NewsletterSection, NewsletterModal, StoreBadge } from '..';
import { External } from '../icons';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

import style from './GameSecretLabPage.module.less';

import hero from './assets/heroSecretLab.jpg';
import newspaper from './assets/newspaper.png';
import logo from './assets/logo.png';
import { ParallelLabVideo } from './ParallelLabVideo';
import splitpuzzle from './assets/split-puzzle.gif';
import adventure from './assets/ck.png';
import watches from './assets/watches.png';
import arcade from './assets/arcade.png';

// screenshots
import screenshot1 from './assets/screenshot1.jpg';
import screenshot2 from './assets/screenshot2.jpg';
import screenshot3 from './assets/screenshot3.jpg';
import screenshot4 from './assets/screenshot4.jpg';
import screenshot5 from './assets/screenshot5.jpg';
import screenshot6 from './assets/screenshot6.jpg';
import screenshot7 from './assets/screenshot7.jpg';
import screenshot8 from './assets/screenshot8.jpg';
import screenshot9 from './assets/screenshot9.jpg';

// reviewers
import theescaperoomer from './assets/theescaperoomer.png';
import chaos from './assets/chaos.png';
import pcmania from './assets/pcmania.png';
import combocaster from './assets/combocaster.png';
import escapetheroomers from './assets/escapetheroomers.jpg';
import reviewtheroom from './assets/reviewtheroom.jpg';
import rea from './assets/rea.png';

// blocks
import browser from './assets/browser.png';
import players from './assets/players.png';
import difficulty from './assets/difficulty.png';
import time from './assets/time.png';
import accessibility from './assets/accessibility.png';
import age from './assets/age.png';
import { FaqSection } from './FaqSection';
import { BuyButton } from '../BuyButton';
import awardETRBestDigitalGame from "./assets/bullseye.png";
import { Link } from "gatsby";

const screenshots = [
  { original: screenshot1 },
  { original: screenshot2 },
  { original: screenshot3 },
  { original: screenshot4 },
  { original: screenshot5 },
  { original: screenshot6 },
  { original: screenshot7 },
  { original: screenshot8 },
  { original: screenshot9 }
];

export const WebGameParallelLabPage = () => {
  const [newsletterOpen, setNewsletterOpen] = useState(false);

  return (
    <Layout transparentTop={true}>
      <SEO
        title="Parallel Lab"
        description="Detectives Ally and Old Dog follow the Cryptic Killer's trail to an old electronics shop. That evening will have them fighting for their lives..."
      />

      <Section className={style.hero} alternate={true} straightTop={true} style={{ backgroundImage: `url(${hero})` }}>
        <div className={style.wrapper}>
          <div className={style.device}>
            <ParallelLabVideo />
          </div>
          <div className={style.game}>
            <img src={logo} alt="Parallel Lab" className={style.gameLogo} />
            <p className={style.tagname}>
              Detectives Ally and Old Dog follow the Cryptic Killer's trail
              <br />
              to an old electronics shop.
              <br />
              That evening will have them fighting for their lives...
            </p>
            <div className={style.buyWrapper}>
              <BuyButton product="secret-lab" text="BUY WEB VERSION" />
            </div>
            <p className={style.priceNote}>Price for a team</p>
            <p className={style.gotAccessCode}>Got a License Key? <a href="https://lab.elevenpuzzles.com?from=website" target="_blank" rel="noreferrer">Click here <External /></a></p>
          </div>
        </div>
        <NewsletterModal isOpen={newsletterOpen} onClose={() => setNewsletterOpen(false)} tags={['parallel-lab', 'website']} />
      </Section>

      <Section className={style.steam}>
        <h1>Looking for a PC, Mac, iOS or Android version?</h1>
        <div className={style.row}>
          <div className={style.content}>
            <div className={style.learnMoreWrapper}>
              <Link className={style.learnMore} to="/unboxing-the-cryptic-killer">Learn more →</Link>
            </div>
          </div>
        </div>
      </Section>

      <Section className={style.aboutParallelLab} alternate={true}>
        <h1>About Parallel Lab</h1>
        <div className={style.row}>
          <div className={style.text}>
            <h2>Co-op puzzle adventure</h2>
            <p>Parallel Lab is a two-player cooperative online puzzle adventure that is all about communication.</p>
            <p>Follow parallel paths, explore a secret laboratory, describe what you see, and work together to unravel the mystery!</p>
          </div>
          <div className={style.image}>
            <img src={adventure} alt="Adventure" />
          </div>
        </div>
        <div className={classNames(style.row, style.alternate)}>
          <div className={style.text}>
            <h2>Split-puzzle experience</h2>
            <p>In Parallel Lab, the detectives are separated. You’ll see different items and clues than your partner. The game will test not only your puzzle-solving skill but also how well you communicate.</p>
          </div>
          <div className={style.image}>
            <img src={splitpuzzle} alt="Split Puzzle" />
          </div>
        </div>
        <div className={style.row}>
          <div className={style.text}>
            <h2>Play in the browser</h2>
            <p>Parallel Lab is played in a browser but controls like a classic point-and-click adventure.</p>
            <p>No outside knowledge is required. You won’t have to open additional browser tabs, no Google search, and don’t need to have social accounts. Just pure, self-contained fun!</p>
          </div>
          <div className={style.image}>
            <img src={arcade} alt="Arcade" />
          </div>
        </div>
        <div className={classNames(style.row, style.alternate)}>
          <div className={style.text}>
            <h2>Play anytime</h2>
            <p>No need for booking. Just get a License Key, gather your team and play!</p>
          </div>
          <div className={style.image}>
            <img src={watches} alt="Watches" />
          </div>
        </div>
      </Section>

      <Section className={style.requirements} alternate={false}>
        <h1>Game requirements & details</h1>
        <div className={style.blocks}>
          <div className={style.block}>
            <img src={browser} alt="Browser" />
            <h3>Modern browser</h3>
            <p>The game requires only a modern browser, no need to install anything!</p>
          </div>
          <div className={style.block}>
            <img src={players} alt="Players" />
            <h3>2-6 players</h3>
            <p>The game requires 2 teams and each team needs a separate device.</p>
          </div>
          <div className={style.block}>
            <img src={age} alt="Age" />
            <h3>Over 8 years old</h3>
            <p>The game is family friendly but the puzzles can be challenging for little ones. Make sure an adult is on their team!</p>
          </div>
          <div className={style.block}>
            <img src={time} alt="Time" />
            <h3>1.5h - 2.5h of playtime</h3>
            <p>Depending on your puzzle-solving experience this may vary, but you can take as long as you need.</p>
          </div>
          <div className={style.block}>
            <img src={difficulty} alt="Difficulty" />
            <h3>4 / 5 difficulty level</h3>
            <p>Don’t worry, you can always use a clue if you’re stuck. No judgement here!</p>
          </div>
          <div className={style.block}>
            <img src={accessibility} alt="Accessibility" />
            <h3>Limited accessibility</h3>
            <p>Sadly, the game is not suitable for people with colour blindness, deafness or HOH. We still welcome you to play with the help of your teammates.</p>
          </div>
        </div>
      </Section>

      <Section className={style.screenshots} alternate={true}>
        <h1>Game screenshots</h1>
        <ImageGallery
          additionalClass={style.gallery}
          items={screenshots}
          showNav={true}
          showThumbnails={false}
          showFullscreenButton={false}
          showPlayButton={false}
          showBullets={false}
        />
      </Section>

      <Section className={style.testimonials} alternate={false}>
        <div className={style.content}>
          <h1>What reviewers are saying about the game?</h1>
          <div className={style.row}>
            <div className={style.testimonial}>
              <div className={style.quote}>
                <p>I thoroughly enjoyed this game. I went in with fairly low expectations but was absolutely blown away. The interactivity and independence are a real positive, and the puzzles themselves were just as good as any physical room.</p>
              </div>
              <img src={theescaperoomer} alt="The Escape Roomer" className={style.avatar} />
              <p className={style.name}>Georgie from The Escape Roomer</p>
              <p className={style.readMore}><a href="https://theescaperoomer.com/parallel-lab-by-eleven-puzzles/" target="_blank">Read the full review <External /></a></p>
            </div>
            <div className={style.testimonial}>
              <div className={style.quote}>
                <p>"Parallel Lab" has an excellent theme and style that draws on classic retro style animation and encourages a level of collaboration while still giving each player something to do, which can be hard to navigate in the online realm of puzzling. Eleven Puzzles does it quite seamlessly!</p>
              </div>
              <img src={escapetheroomers} alt="ESCAPETHEROOMers" className={style.avatar} />
              <p className={style.name}>ESCAPETHEROOMers</p>
              <p className={style.readMore}><a href="https://www.escapetheroomers.com/post/eleven-puzzles-parallel-lab" target="_blank">Read the full review <External /></a></p>
            </div>
          </div>
          <div className={style.row}>
            <div className={style.testimonial}>
              <div className={style.quote}>
                <p>If you liked the first game by Eleven Puzzles, then this one is sure to be a hit. Eleven Puzzles take their time with their games, and it shows, this is a quality experience.</p>
              </div>
              <img src={reviewtheroom} alt="Review The Room" className={style.avatar} />
              <p className={style.name}>Review The Room</p>
              <p className={style.readMore}><a href="https://www.reviewtheroom.co.uk/eleven-puzzles-parallel-lab-play-at-home/" target="_blank">Read the full review <External /></a></p>
            </div>
            <div className={style.testimonial}>
              <div className={style.quote}>
                <p>Parallel Lab is a fun cooperative experience that should have players delighting in their shared adventure.</p>
              </div>
              <img src={chaos} alt="Chaos & Confetti" className={style.avatar} />
              <p className={style.name}>Chaos & Confetti</p>
              <p className={style.readMore}><a href="https://chaosyconfetti.com/2022/04/24/parallel-lab-by-eleven-puzzles/" target="_blank">Read the full review <External /></a></p>
            </div>
          </div>
          <div className={style.row}>
            <div className={style.testimonial}>
              <div className={style.quote}>
                <p>Parallel Labs really leans into cooperative gameplay to deliver a quality experience that’s just plain fun.</p>
              </div>
              <img src={rea} alt="Room Escape Artist" className={style.avatar} />
              <p className={style.name}>Room Escape Artist</p>
              <p className={style.readMore}><a href="https://roomescapeartist.com/2022/07/25/eleven-puzzles-parallel-lab-hivemind-review/" target="_blank">Read the full review <External /></a></p>
            </div>
            <div className={style.testimonial}>
              <div className={style.quote}>
                <p>The puzzles are very well done and have the perfect level of difficulty - the answers are not super obvious, you are guided only by your logic. Overall, I liked the game and I rate it 5/6 because it was fun.</p>
              </div>
              <img src={pcmania} alt="PC Mania" className={style.avatar} />
              <p className={style.name}>PC Mania</p>
              <p className={style.readMore}><a href="https://pcmania.bg/2022/05/13/eleven-puzzles-parallel-lab-review/" target="_blank">Read the full review in Bulgarian <External /></a></p>
            </div>
          </div>
          <div className={style.row}>
            <div className={style.testimonial}>
              <div className={style.quote}>
                <p>Parallel Lab is an interesting game, with an innovative concept and technology that works surprisingly well. It’s very rare for a game to appear that does something really different and Parallel Lab succeeds.</p>
              </div>
              <img src={combocaster} alt="Combo Caster" className={style.avatar} />
              <p className={style.name}>Combo Caster</p>
              <p className={style.readMore}><a href="https://combocaster.pt/2022/05/analise-parallel-lab/" target="_blank">Read the full review in Portuguese <External /></a></p>
            </div>
          </div>
        </div>
      </Section>

      <Section className={style.awards} alternate={true}>
        <div className={style.content}>
          <h1>Awards</h1>
          <div className={style.row}>
            <div className={style.award}>
              <img src={awardETRBestDigitalGame} alt="Best Digital Game" />
            </div>
          </div>
        </div>
      </Section>

      <Section className={style.gameStory} alternate={false}>
        <div className={style.content}>
          <h1>Game story</h1>
          <div className={style.row}>
            <div className={style.newspaper}>
              <img src={newspaper} alt="Newspaper" />
            </div>
            <div className={style.story}>
              <h2>The detectives are following Cryptic Killer's trail</h2>
              <p>After escaping Cryptic Killer's trap, the detectives thoroughly investigated the area where they had been held. Sadly they have found nothing that could move their case closer to catching the killer... Or so they thought.</p>
              <p>Later that week, one of the engineers at the police station mentioned that the electronic equipment used to make the traps was quite old and specific. Luckily, there was only one old shop in the area that was still selling devices like that.</p>
              <p>Armed with the new knowledge, Ally and Old Dog decided to visit the electronic shop to ask a few questions. Little did they know that that evening would have them fighting for their lives...</p>
            </div>
          </div>
        </div>
      </Section>

      <FaqSection />

      <NewsletterSection />
    </Layout>
  )
};
